import { months, MonthYear } from '../../../utils/MonthYear/monthYear';
import { StackedBarChartElement } from '@sp-types/dashboardTypes';
import { getMonthYear } from '../../FinancialPositions/components/FinancialPositionsUtils';

const getKey = (date: MonthYear): string => `${date.year}-${date.month}`;
const getDateKey = (now: Date, addMonths: number): string =>
  getKey(getMonthYear(new Date(now.getFullYear(), now.getMonth() + addMonths, 2)));

const sumMaterialsValues = (materialHashes: { monthHash: Record<string, number> }[], monthKey: string) =>
  materialHashes.reduce((sum, { monthHash }) => sum + (monthHash[monthKey] || 0), 0);

export const calcMaxVal = (barChartDat: StackedBarChartElement[], isGeneral: boolean): number => {
  const now = new Date();

  if (isGeneral) {
    const materialMonthHash = barChartDat.map(({ materialId, valueArray }) => ({
      materialId,
      monthHash: valueArray.reduce(
        (acc, { date, value }) => ({ ...acc, [getKey(date)]: value }),
        {} as Record<string, number>,
      ),
    }));
    const monthKeys = [getDateKey(now, -1), ...months.map((_m, i) => getDateKey(now, i))];

    return Math.max(...monthKeys.map((month) => sumMaterialsValues(materialMonthHash, month)), 1);
  } else {
    return Math.max(
      ...(barChartDat
        .find(({ materialId }) => !!materialId && materialId !== 'placeholder')
        ?.valueArray?.map(({ value }) => value) || []),
      1,
    );
  }
};
